import { render, staticRenderFns } from "./cargo-list.vue?vue&type=template&id=f8c6cfbe&scoped=true"
import script from "./cargo-list.vue?vue&type=script&lang=js"
export * from "./cargo-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c6cfbe",
  null
  
)

export default component.exports